<div class="relative">
  <div
    class="text-center border rounded-full {{ extraClass }}"
    [ngClass]="{
      'm-size': size === 'm',
      's-size': size === 's',
      'xs-size': size === 'xs',
      'bg-primary/15 dark:bg-primary/55 border-transparent text-txt': selected,
      'border-gray-100 text-txt': !selected && !variant,
      'hover:bg-ui-hover': !selected && hasHoverEffect,
      'cursor-pointer': hasHoverEffect,
      'variant-info': !selected && variant === 'info',
      'variant-success': !selected && variant === 'success',
      'variant-error': !selected && variant === 'error',
      'variant-warning': !selected && variant === 'warning',
      'variant-neutral': !selected && variant === 'neutral'
    }"
  >
    {{ label }}
  </div>
</div>
